export type ParticipantAcces = {
	role: number,
	id: number,
}

export abstract class BasicAccesOrder {
	intervenants!:  ParticipantAcces[];
	entreprises!: ParticipantAcces[];

	commentaire!: string;
	astreinte!: boolean;

	constructor() {
	}
}